/* Artwork slider */
/* Shown on the project pages displayed by project-slider */
/* -------------------------------------------- */
function initArtworkSlider() {
    var carouselContainer = $('#artwork-carousel-container');
    var carousel = $('.artwork-carousel');
    var body = $('body');
    var slideWidth = $('.artwork-slide:not(.artwork-slide-first)').width();
    var threshold = 300;
    var dragStart, dragEnd;
    var carouselTransform = 0;
    var carouselClicks = 1;

    // Give the first child the active class on initial load
    $('.artwork-slide:nth-child(1)').addClass('active');

    $('.artwork-slider-prev').click(function(){ artworkSliderShift(1) })
    $('.artwork-slider-next').click(function(){ artworkSliderShift(-1) })

    carousel.on('mousedown', function() {
        if (carousel.hasClass('transition')) return;

        dragStart = event.pageX;
        $(this).on('mousemove', function(){
            dragEnd = event.pageX;
            $(this).css('transform', 'translateX('+ dragPos() + 'px)');
        })
        $(document).on('mouseup', function(){
            if (dragLength() > 50 && carouselClicks != 1) { 
                return artworkSliderShift(1) 
            } else if (dragLength() < -50 && carouselClicks != $('.artwork-slide').length) { 
                return artworkSliderShift(-1)
            } else if (dragLength() >= -50 && dragLength() <= 50) { 
                return artworkSliderShift(0) ;
            } 
            setTimeout(function() {
                carousel.removeClass('transition');
            }, 700)
        })
    });

    // Touch support
    carousel.on('touchstart', function() {
        if (carousel.hasClass('transition')) return;

        dragStart = event.touches[0].pageX;
        $(this).on('touchmove', function(){
            dragEnd = event.touches[0].pageX;
            $(this).css('transform', 'translateX('+ dragPos() + 'px)');
        })
        $(document).on('touchend', function(){
            if (dragLength() > 75 && carouselClicks != 1) { 
                return artworkSliderShift(1) 
            } else if (dragLength() < -75 && carouselClicks != $('.artwork-slide').length) { 
                return artworkSliderShift(-1)
            } else { 
                return artworkSliderShift(0) ;
            } 
            setTimeout(function() {
                carousel.removeClass('transition');
            }, 700)
        })
    });

    carousel.on('touchcancel', function() {
        return artworkSliderShift(0);
    });

    function dragPos() {
        return carouselTransform + (dragEnd - dragStart);
    }

    function dragLength() {
        return dragEnd - dragStart;
    }

    function artworkSliderShift(direction) {
        if (carousel.hasClass('transition')) return;

        if (direction === 1) {
            carouselTransform = carouselTransform + slideWidth;
            carouselClicks = carouselClicks - 1;
        } else if (direction === -1) {
            carouselTransform = carouselTransform - slideWidth;
            carouselClicks = carouselClicks + 1;
        }

        $(document).off('mouseup')
        carousel.off('mousemove')
                .addClass('transition')
                .css('transform', 'translateX(' + carouselTransform + 'px)');

        $(document).off('touchend')
        carousel.off('touchmove')
                .addClass('transition')
                .css('transform', 'translateX(' + carouselTransform + 'px)');

        setTimeout(function() {
            carousel.removeClass('transition');
            carousel.css('transform', 'translateX(' + carouselTransform + 'px)');
        }, 700)

        if (direction === 1) {
            $('.artwork-slide').removeClass('active');
            $('.artwork-slide:nth-child(' + carouselClicks + ')').addClass('active');
        } else if (direction === -1) {
            $('.artwork-slide').removeClass('active');
            $('.artwork-slide:nth-child(' + carouselClicks +')').addClass('active');
        }
        artworkCountSlides();
    }

    function artworkCountSlides() {
        setTimeout(function() {
            if (carouselClicks == 1) {
                $('.artwork-slider-prev').addClass('hide');
                $('.artwork-slider-next').removeClass('hide')
            } else if (carouselClicks == $('.artwork-slide').length) {
                $('.artwork-slider-next').addClass('hide')
                $('.artwork-slider-prev').removeClass('hide')
            } else {
                $('.artwork-slider-next, .artwork-slider-prev').removeClass('hide')
            }
        }, 200)
    }
}

initArtworkSlider();
